(function () {
  'use strict';

  function readJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function money(cents, config) {
    var value = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, config.moneyFormat);
    }
    if (window.IWCurrency && typeof window.IWCurrency.formatMinor === 'function') {
      return window.IWCurrency.formatMinor(value);
    }
    return (value / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: config.currency || 'USD'
    });
  }

  function cartUrl(path) {
    if (window.IWCurrency && typeof window.IWCurrency.cartUrl === 'function') {
      return window.IWCurrency.cartUrl(path);
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  function numericResourceId(id) {
    var normalized = String(id == null ? '' : id).split('/').pop();
    var numericId = Number(normalized);
    return Number.isFinite(numericId) ? numericId : normalized;
  }

  function setButtonState(button, label, disabled) {
    if (!button) return;
    button.textContent = label;
    button.disabled = Boolean(disabled);
  }

  function publishCartUpdate(cart, config, quantity) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: config.formId,
        data: {
          source: 'iwobbl-finished-product-detail',
          itemCount: quantity,
          productId: config.productId
        }
      }
    }));

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
  }

  function track(name, payload) {
    try {
      if (window.IWAnalytics && typeof window.IWAnalytics.track === 'function') {
        window.IWAnalytics.track(name, payload || {});
      }
    } catch (error) {}
  }

  function init(root) {
    if (!root || root.dataset.ready === 'true' || root.dataset.ready === 'error') return;

    var product = readJson(root, '[data-iw-fp-product-json]');
    var config = readJson(root, '[data-iw-fp-config-json]');
    var galleryMode = root.dataset.iwFpGalleryMode === 'sku_scoped' ? 'sku_scoped' : 'shared';
    var variantGalleryMap = readJson(root, '[data-iw-fp-variant-gallery-json]') || {};
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      root.dataset.ready = 'error';
      track('finished_product_load_error', {
        result: 'error',
        error_code: 'product_data_invalid',
        gallery_mode: galleryMode
      });
      return;
    }
    if (!config || !config.productId || !config.initialVariantId) {
      root.dataset.ready = 'error';
      track('finished_product_load_error', {
        result: 'error',
        error_code: 'config_data_invalid',
        gallery_mode: galleryMode
      });
      return;
    }

    root.dataset.ready = 'true';

    var form = root.querySelector('[data-iw-fp-form]');
    var variantInput = root.querySelector('[data-iw-fp-variant-id]');
    var quantityInput = root.querySelector('[data-iw-fp-quantity]');
    var addButton = root.querySelector('[data-iw-fp-add]');
    var buyButton = root.querySelector('[data-iw-fp-buy]');
    var priceCurrent = root.querySelector('[data-iw-fp-price-current]');
    var priceCompare = root.querySelector('[data-iw-fp-price-compare]');
    var saleBadge = root.querySelector('[data-iw-fp-sale]');
    var availability = root.querySelector('[data-iw-fp-availability]');
    var status = root.querySelector('[data-iw-fp-status]');
    var sizeMeta = root.querySelector('[data-iw-fp-size-meta]');
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-iw-fp-option]'));
    var selectedOptions = [];
    var activeVariant = product.variants.find(function (variant) {
      return String(variant.id) === String(config.initialVariantId);
    }) || product.variants[0];
    var submitting = false;
    var analyticsStartedAt = Date.now();
    var activeStartedAt = document.visibilityState === 'hidden' ? 0 : analyticsStartedAt;
    var activeMilliseconds = 0;
    var interactionCount = 0;
    var variantSwitchCount = 0;
    var maxScrollPercent = 0;
    var exitSummarySent = false;

    function productPayload(payload) {
      return Object.assign({
        product_id: String(config.productId),
        variant_id: activeVariant ? String(activeVariant.id) : '',
        product_type: String(config.productType || '').toLowerCase(),
        page_handle: String(config.productHandle || ''),
        template_suffix: 'finished-jewelry',
        currency: String(config.currency || ''),
        value: activeVariant ? Number(activeVariant.price || 0) / 100 : 0,
        gallery_mode: galleryMode
      }, payload || {});
    }

    function trackProduct(name, payload) {
      track(name, productPayload(payload));
    }

    function trackInteraction(name, payload) {
      interactionCount += 1;
      trackProduct(name, payload);
    }

    function updateAnalyticsProductContext(variant) {
      if (!variant) return;
      try {
        if (window.IWAnalytics && typeof window.IWAnalytics.setProductContext === 'function') {
          window.IWAnalytics.setProductContext({
            variant_id: String(variant.id),
            value: Number(variant.price || 0) / 100
          });
        }
      } catch (error) {}
    }

    function announce(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.dataset.error = isError ? 'true' : 'false';
    }

    function variantByOptions() {
      return product.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return selectedOptions[index] === option;
        });
      }) || null;
    }

    function updateOptionAvailability() {
      optionButtons.forEach(function (button) {
        var index = Number(button.dataset.optionIndex);
        var value = button.dataset.optionValue;
        var possible = product.variants.some(function (variant) {
          if (!variant.available || variant.options[index] !== value) return false;
          return variant.options.every(function (option, optionIndex) {
            return optionIndex === index || selectedOptions[optionIndex] === option;
          });
        });
        button.disabled = !possible;
        button.setAttribute('aria-disabled', possible ? 'false' : 'true');
      });
    }

    function updateVariant(variant, replaceUrl) {
      activeVariant = variant;
      if (!variant) {
        if (variantInput) variantInput.value = '';
        setButtonState(addButton, 'Unavailable', true);
        setButtonState(buyButton, 'Unavailable', true);
        if (availability) availability.textContent = 'This option combination is unavailable.';
        return;
      }

      updateAnalyticsProductContext(variant);
      if (variantInput) variantInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = money(variant.price, config);

      var compareAt = Number(variant.compare_at_price || 0);
      var price = Number(variant.price || 0);
      if (priceCompare) {
        priceCompare.textContent = compareAt > price ? money(compareAt, config) : '';
        priceCompare.hidden = !(compareAt > price);
      }
      if (saleBadge) {
        if (compareAt > price) {
          saleBadge.textContent = '−' + Math.round((1 - price / compareAt) * 100) + '%';
          saleBadge.hidden = false;
        } else {
          saleBadge.hidden = true;
        }
      }

      setButtonState(addButton, variant.available ? 'Add to Cart' : 'Sold Out', !variant.available);
      setButtonState(buyButton, variant.available ? 'Buy Now' : 'Sold Out', !variant.available);
      if (availability) {
        availability.textContent = variant.available ? config.availableLabel : config.soldOutLabel;
      }
      if (sizeMeta && Array.isArray(variant.options) && variant.options.length) {
        sizeMeta.textContent = variant.options[0];
      }

      if (replaceUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selectedOptions = activeVariant.options.slice();
    optionButtons.forEach(function (button) {
      var index = Number(button.dataset.optionIndex);
      var selected = selectedOptions[index] === button.dataset.optionValue;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var previousValue = selectedOptions[index];
        if (previousValue === button.dataset.optionValue) return;
        selectedOptions[index] = button.dataset.optionValue;
        optionButtons.forEach(function (candidate) {
          if (Number(candidate.dataset.optionIndex) !== index) return;
          var isSelected = candidate.dataset.optionValue === selectedOptions[index];
          candidate.classList.toggle('is-selected', isSelected);
          candidate.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        var nextVariant = variantByOptions();
        updateVariant(nextVariant, true);
        showVariantImage(nextVariant);
        updateOptionAvailability();
        announce('');
        variantSwitchCount += 1;
        trackInteraction('finished_product_variant_select', {
          option_name: String(button.dataset.optionName || ''),
          option_value: String(button.dataset.optionValue || ''),
          variant_id: nextVariant ? String(nextVariant.id) : '',
          value: nextVariant ? Number(nextVariant.price || 0) / 100 : 0,
          available: Boolean(nextVariant && nextVariant.available),
          result: nextVariant && nextVariant.available ? 'success' : 'unavailable',
          switch_count: variantSwitchCount
        });
      });
    });
    updateVariant(activeVariant, false);
    updateOptionAvailability();

    var lastQuantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
    function updateQuantity(nextValue, interactionType) {
      if (!quantityInput) return;
      var next = Math.max(1, Number(nextValue || 1));
      quantityInput.value = next;
      if (next === lastQuantity) return;
      lastQuantity = next;
      trackInteraction('finished_product_quantity_change', {
        quantity: next,
        interaction_type: interactionType,
        change_method: interactionType
      });
    }

    root.querySelectorAll('[data-iw-fp-qty-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!quantityInput) return;
        var delta = Number(button.dataset.iwFpQtyChange || 0);
        updateQuantity(
          Number(quantityInput.value || 1) + delta,
          delta < 0 ? 'decrease' : 'increase'
        );
      });
    });
    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        updateQuantity(quantityInput.value, 'input');
      });
    }

    function cartErrorCode(error) {
      if (error && error.name === 'AbortError') return 'cart_add_timeout';
      if (error && error.analyticsCode) return error.analyticsCode;
      if (error && error.name === 'SyntaxError') return 'cart_response_invalid';
      if (error && error.name === 'TypeError') return 'cart_network_error';
      return 'cart_request_failed';
    }

    async function addCurrentVariant(mode) {
      if (submitting || !activeVariant || !activeVariant.available) return;
      submitting = true;
      announce('');
      var submittedVariant = activeVariant;
      var quantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
      setButtonState(addButton, mode === 'cart' ? 'Adding…' : 'Add to Cart', true);
      setButtonState(buyButton, mode === 'checkout' ? 'Preparing…' : 'Buy Now', true);

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeout = controller ? setTimeout(function () { controller.abort(); }, 12000) : null;

      trackInteraction(mode === 'checkout' ? 'finished_product_buy_now_click' : 'finished_product_add_to_cart_click', {
        product_id: String(config.productId),
        variant_id: String(submittedVariant.id),
        quantity: quantity,
        value: Number(submittedVariant.price || 0) / 100,
        currency: config.currency
      });

      try {
        var response = await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: numericResourceId(submittedVariant.id),
              quantity: quantity
            }]
          }),
          signal: controller ? controller.signal : undefined
        });
        var payload = await response.json();
        if (!response.ok || payload.status) {
          var requestError = new Error(payload.description || payload.message || config.cartErrorLabel);
          requestError.analyticsCode = response.status === 422 ? 'cart_add_rejected' : 'cart_http_error';
          throw requestError;
        }

        if (mode === 'checkout') {
          trackProduct('finished_product_buy_now', {
            result: 'handoff',
            product_id: String(config.productId),
            variant_id: String(submittedVariant.id),
            quantity: quantity,
            value: Number(submittedVariant.price || 0) / 100
          });
          if (
            window.IWWelcomeDiscount
            && typeof window.IWWelcomeDiscount.prepareCartCheckout === 'function'
          ) {
            await window.IWWelcomeDiscount.prepareCartCheckout();
          }
          window.location.assign(cartUrl('checkout'));
          return;
        }

        var cart = null;
        try {
          var cartResponse = await fetch(cartUrl('cart.js'), {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          cart = cartResponse.ok ? await cartResponse.json() : null;
        } catch (cartRefreshError) {}
        if (cart) publishCartUpdate(cart, config, quantity);
        announce(config.addedLabel, false);
        trackProduct('finished_product_add_to_cart', {
          result: 'success',
          product_id: String(config.productId),
          variant_id: String(submittedVariant.id),
          quantity: quantity,
          value: Number(submittedVariant.price || 0) / 100
        });
      } catch (error) {
        var message = error && error.name === 'AbortError'
          ? config.timeoutLabel
          : (error && error.message) || config.cartErrorLabel;
        announce(message, true);
        trackProduct(mode === 'checkout' ? 'finished_product_buy_now' : 'finished_product_add_to_cart', {
          result: 'error',
          product_id: String(config.productId),
          variant_id: String(submittedVariant.id),
          value: Number(submittedVariant.price || 0) / 100,
          error_code: cartErrorCode(error)
        });
      } finally {
        if (timeout) clearTimeout(timeout);
        submitting = false;
        if (activeVariant) updateVariant(activeVariant, false);
      }
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addCurrentVariant('cart');
      });
    }
    if (buyButton) {
      buyButton.addEventListener('click', function () {
        addCurrentVariant('checkout');
      });
    }

    var mainImage = root.querySelector('[data-iw-fp-main-image]');
    var mainTrigger = root.querySelector('[data-iw-fp-main-trigger]');
    var thumbButtons = Array.prototype.slice.call(root.querySelectorAll('[data-iw-fp-thumb]'));
    var allImages = thumbButtons.map(function (button) {
      return {
        id: String(button.dataset.imageId || ''),
        mediaId: String(button.dataset.mediaId || ''),
        src: button.dataset.imageSrc,
        srcset: button.dataset.imageSrcset || '',
        alt: button.dataset.imageAlt || config.productTitle,
        button: button
      };
    });
    var images = allImages.slice();
    var activeImageIndex = 0;
    var galleryInteracted = false;
    var mainImageErrorSent = false;
    var initialActiveIndex = thumbButtons.findIndex(function (button) {
      return button.classList.contains('is-active');
    });
    if (initialActiveIndex >= 0) activeImageIndex = initialActiveIndex;

    function trackGallery(interactionType, index) {
      trackInteraction('finished_product_gallery_interact', {
        interaction_type: interactionType,
        image_index: Math.max(0, Number(index || 0)) + 1,
        image_count: images.length,
        first_interaction: !galleryInteracted
      });
      galleryInteracted = true;
    }

    function reportMainImageError() {
      if (mainImageErrorSent) return;
      mainImageErrorSent = true;
      trackProduct('finished_product_load_error', {
        result: 'error',
        error_code: 'main_image_load_failed'
      });
    }

    if (mainImage) {
      mainImage.addEventListener('error', function () {
        if (mainImageErrorSent) return;
        reportMainImageError();
      });
      if (mainImage.complete && !mainImage.naturalWidth) reportMainImageError();
    }

    function showImage(index) {
      if (!images.length || index < 0 || index >= images.length) return;
      activeImageIndex = index;
      if (mainImage) {
        if (images[index].srcset) {
          mainImage.srcset = images[index].srcset;
        } else {
          mainImage.removeAttribute('srcset');
        }
        mainImage.src = images[index].src;
        mainImage.alt = images[index].alt;
      }
      if (mainTrigger) {
        mainTrigger.setAttribute('aria-label', 'Open image ' + (index + 1) + ' of ' + images.length + ' fullscreen');
      }
      allImages.forEach(function (image) {
        var isActive = image.button === images[index].button;
        var button = image.button;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function variantImageId(variant) {
      if (!variant) return '';
      var featuredImage = variant.featured_image;
      if (featuredImage && featuredImage.id) return String(featuredImage.id);
      var featuredMedia = variant.featured_media;
      if (featuredMedia && featuredMedia.id) return String(featuredMedia.id);
      return '';
    }

    function normalizeResourceId(id) {
      return String(id == null ? '' : id).split('/').pop();
    }

    function mappedMediaIds(variant) {
      if (!variant || !variantGalleryMap || typeof variantGalleryMap !== 'object') return [];
      var variantId = normalizeResourceId(variant.id);
      var matchingKey = Object.keys(variantGalleryMap).find(function (key) {
        return normalizeResourceId(key) === variantId;
      });
      var mapped = matchingKey ? variantGalleryMap[matchingKey] : [];
      if (!Array.isArray(mapped)) return [];
      return mapped.map(normalizeResourceId).filter(Boolean);
    }

    function useSharedGallery() {
      images = allImages.slice();
      allImages.forEach(function (image) {
        image.button.hidden = false;
      });
    }

    function useScopedGallery(variant) {
      var mediaIds = mappedMediaIds(variant);
      if (!mediaIds.length) {
        var representativeId = normalizeResourceId(variantImageId(variant));
        mediaIds = representativeId ? [representativeId] : [];
      }

      images = allImages.filter(function (image) {
        return mediaIds.indexOf(normalizeResourceId(image.mediaId)) >= 0;
      });
      allImages.forEach(function (image) {
        image.button.hidden = images.indexOf(image) < 0;
      });
      images.forEach(function (image, index) {
        image.button.setAttribute('aria-label', 'Show image ' + (index + 1) + ' of ' + images.length);
      });
    }

    function showVariantImage(variant) {
      if (galleryMode === 'sku_scoped') {
        useScopedGallery(variant);
      } else {
        useSharedGallery();
      }

      if (!images.length) return false;
      var imageId = variantImageId(variant);
      if (!imageId) return false;
      var index = images.findIndex(function (image) {
        return normalizeResourceId(image.id) === normalizeResourceId(imageId);
      });
      if (index < 0 && galleryMode === 'sku_scoped') index = 0;
      if (index < 0) return false;
      showImage(index);
      return true;
    }

    showVariantImage(activeVariant);

    thumbButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = images.findIndex(function (image) {
          return image.button === button;
        });
        if (index >= 0) {
          showImage(index);
          trackGallery('thumbnail', index);
        }
      });
    });

    var viewer = root.querySelector('[data-iw-fp-viewer]');
    var viewerImage = root.querySelector('[data-iw-fp-viewer-image]');
    var viewerCount = root.querySelector('[data-iw-fp-viewer-count]');
    var viewerClose = root.querySelector('[data-iw-fp-viewer-close]');
    var viewerPrevious = root.querySelector('[data-iw-fp-viewer-prev]');
    var viewerNext = root.querySelector('[data-iw-fp-viewer-next]');

    function updateViewer() {
      if (!images.length || !viewerImage) return;
      viewerImage.src = images[activeImageIndex].src;
      viewerImage.alt = images[activeImageIndex].alt;
      if (viewerCount) viewerCount.textContent = (activeImageIndex + 1) + ' / ' + images.length;
      if (viewerPrevious) viewerPrevious.disabled = activeImageIndex === 0;
      if (viewerNext) viewerNext.disabled = activeImageIndex === images.length - 1;
    }

    if (mainTrigger && viewer && images.length) {
      mainTrigger.addEventListener('click', function () {
        updateViewer();
        if (typeof viewer.showModal === 'function') viewer.showModal();
        else viewer.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        trackGallery('fullscreen_open', activeImageIndex);
      });
    }
    if (viewerClose) {
      viewerClose.addEventListener('click', function () {
        if (viewer && typeof viewer.close === 'function') viewer.close();
        else if (viewer) viewer.removeAttribute('open');
        document.documentElement.style.overflow = '';
      });
    }
    if (viewerPrevious) {
      viewerPrevious.addEventListener('click', function () {
        if (activeImageIndex <= 0) return;
        activeImageIndex -= 1;
        updateViewer();
        trackGallery('fullscreen_previous', activeImageIndex);
      });
    }
    if (viewerNext) {
      viewerNext.addEventListener('click', function () {
        if (activeImageIndex >= images.length - 1) return;
        activeImageIndex += 1;
        updateViewer();
        trackGallery('fullscreen_next', activeImageIndex);
      });
    }
    if (viewer) {
      viewer.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
      });
      viewer.addEventListener('click', function (event) {
        if (event.target !== viewer) return;
        if (typeof viewer.close === 'function') viewer.close();
      });
    }

    root.querySelectorAll('.iw-fp__detail').forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (!detail.open) return;
        root.querySelectorAll('.iw-fp__detail[open]').forEach(function (other) {
          if (other !== detail) other.open = false;
        });
        trackInteraction('finished_product_accordion_open', {
          section_name: String(detail.dataset.iwFpAccordion || 'details'),
          interaction_type: 'open'
        });
      });
    });

    root.querySelectorAll('[data-iw-fp-size-guide]').forEach(function (link) {
      link.addEventListener('click', function () {
        trackInteraction('finished_product_size_guide_click', {
          cta_placement: String(link.dataset.iwFpLinkLocation || 'unknown'),
          destination: 'size_guide'
        });
      });
    });

    var videoWall = root.querySelector('[data-iw-fp-video-wall]');
    if (videoWall) {
      videoWall.addEventListener('click', function (event) {
        var card = event.target.closest('.iwv-card');
        if (!card || !videoWall.contains(card)) return;
        var videoType = /^(native|youtube|vimeo)$/.test(String(card.dataset.type || ''))
          ? String(card.dataset.type)
          : 'unknown';
        trackInteraction('finished_product_video_open', {
          section_name: 'video',
          interaction_type: 'open_' + videoType
        });
      });
    }

    var startDesignLink = root.querySelector('[data-iw-fp-start-design]');
    if (startDesignLink) {
      startDesignLink.addEventListener('click', function () {
        trackInteraction('finished_product_start_design_click', {
          cta_placement: 'bottom',
          destination: 'designer'
        });
      });
    }

    var reviewTrack = root.querySelector('[data-iw-fp-review-track]');
    var reviewPrevious = root.querySelector('[data-iw-fp-review-prev]');
    var reviewNext = root.querySelector('[data-iw-fp-review-next]');
    var reviewAll = root.querySelector('[data-iw-fp-review-action="see_all"]');
    if (reviewAll) {
      reviewAll.addEventListener('click', function () {
        trackInteraction('finished_product_review_interact', {
          section_name: 'reviews',
          interaction_type: 'see_all'
        });
      });
    }
    if (reviewTrack && reviewPrevious && reviewNext) {
      function updateReviewControls() {
        var max = Math.max(0, reviewTrack.scrollWidth - reviewTrack.clientWidth);
        reviewPrevious.disabled = reviewTrack.scrollLeft <= 2;
        reviewNext.disabled = reviewTrack.scrollLeft >= max - 2;
      }
      function scrollReviews(direction) {
        var card = reviewTrack.querySelector('.iw-fp__review-card');
        var amount = card ? card.getBoundingClientRect().width + 14 : reviewTrack.clientWidth * 0.82;
        reviewTrack.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }
      reviewPrevious.addEventListener('click', function () {
        scrollReviews(-1);
        trackInteraction('finished_product_review_interact', {
          section_name: 'reviews',
          interaction_type: 'previous'
        });
      });
      reviewNext.addEventListener('click', function () {
        scrollReviews(1);
        trackInteraction('finished_product_review_interact', {
          section_name: 'reviews',
          interaction_type: 'next'
        });
      });
      reviewTrack.addEventListener('scroll', updateReviewControls, { passive: true });
      window.addEventListener('resize', updateReviewControls, { passive: true });
      updateReviewControls();
    }

    if ('IntersectionObserver' in window) {
      var viewedSections = {};
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var sectionName = String(entry.target.dataset.iwFpSection || '');
          if (!entry.isIntersecting || !sectionName || viewedSections[sectionName]) return;
          viewedSections[sectionName] = true;
          trackProduct('finished_product_section_view', {
            section_name: sectionName
          });
          sectionObserver.unobserve(entry.target);
        });
      }, { threshold: 0.35 });
      root.querySelectorAll('[data-iw-fp-section]').forEach(function (section) {
        sectionObserver.observe(section);
      });
    }

    function updateMaxScroll() {
      var pageHeight = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
      if (!pageHeight) return;
      var percent = Math.round((window.scrollY + window.innerHeight) / pageHeight * 100);
      maxScrollPercent = Math.max(maxScrollPercent, Math.min(100, percent));
    }

    function settleActiveTime() {
      if (!activeStartedAt) return;
      activeMilliseconds += Math.max(0, Date.now() - activeStartedAt);
      activeStartedAt = 0;
    }

    function sendExitSummary(reason) {
      if (exitSummarySent) return;
      settleActiveTime();
      updateMaxScroll();
      exitSummarySent = true;
      trackProduct('finished_product_exit_summary', {
        active_seconds: Math.round(activeMilliseconds / 1000),
        interaction_count: interactionCount,
        gallery_image_count: images.length,
        max_scroll_pct: maxScrollPercent,
        variant_switch_count: variantSwitchCount,
        interaction_type: reason
      });
    }

    updateMaxScroll();
    window.addEventListener('scroll', updateMaxScroll, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        sendExitSummary('visibility_hidden');
      } else if (!exitSummarySent && !activeStartedAt) {
        activeStartedAt = Date.now();
      }
    });
    window.addEventListener('pagehide', function () {
      sendExitSummary('pagehide');
    });

    var loadMilliseconds = window.performance && typeof window.performance.now === 'function'
      ? Math.max(0, Math.round(window.performance.now()))
      : Math.max(0, Date.now() - analyticsStartedAt);
    trackProduct('finished_product_ready', {
      result: 'success',
      load_ms: loadMilliseconds,
      gallery_image_count: images.length
    });
  }

  function initAll() {
    document.querySelectorAll('[data-iw-fp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
